package nl.volleyplanner.api.planner

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import nl.volleyplanner.api.sports.MatchEvent

@Suppress("TRANSIENT_IS_REDUNDANT")
@Serializable
data class TaskDaysResponse(
    val planningProblem: PlanningProblem,
    val planningProblemVersion: PlanningProblemVersion?,
    val taskDays: List<TaskDay>
) {
    @Transient
    val matchesByTaskId by lazy {
        taskDays.flatMap { taskDay -> taskDay.matches.flatMap { match -> match.allTasks.map { it.id to match} } }
            .toMap()
    }

    @Transient
    val allMatchTasks by lazy { taskDays.flatMap { it.matches.flatMap { it.allTasks } } }

}

@Serializable
data class TaskDay(
    val date: LocalDate,
    val clubhouseTasks: List<Task>,
    val accommodationTasks: List<Task>,
    val matches: List<MatchEvent>
)
